import { Icon } from './Icon';
import type { Member } from '../types';

export function renderBlockCell(
  perf: string,
  behavior: string,
  title: string,
  styleClasses: string,
  members: Member[],
  onMemberClick: (m: Member) => void,
  isDark = false
) {
  const cellMembers = members.filter(
    (m) => m.finalPerf === perf && m.finalBehavior === behavior
  );

  return (
    <div
      className={`p-3 rounded-xl border flex flex-col justify-between ${styleClasses} min-h-[140px] transition-all`}
    >
      <div>
        <span
          className={`text-[10px] font-bold block leading-tight ${isDark ? 'text-indigo-300' : 'text-slate-500'}`}
        >
          {title}
        </span>
        <span className="text-[9px] block text-slate-400 mt-0.5">
          ({perf} - {behavior})
        </span>
      </div>

      <div className="space-y-1 mt-2 flex-grow overflow-y-auto max-h-[80px]">
        {cellMembers.map((m) => (
          <div
            key={m.id}
            onClick={() => onMemberClick(m)}
            className={`px-2 py-1.5 rounded-lg text-[10px] font-bold shadow-sm transition-all cursor-pointer flex justify-between items-center ${isDark ? 'bg-slate-800 text-white border border-slate-700 hover:bg-slate-700' : 'bg-white text-slate-800 border border-slate-200 hover:border-indigo-400 hover:bg-indigo-50/10'}`}
          >
            <span className="truncate max-w-[80px]">
              {m.name} {m.duty}
            </span>
            <Icon name="edit-3" className="w-2.5 h-2.5 opacity-60 flex-shrink-0" />
          </div>
        ))}
      </div>

      <div className="text-right mt-1">
        <span className={`text-[9px] font-extrabold ${isDark ? 'text-indigo-400' : 'text-indigo-600'}`}>
          {cellMembers.length}명
        </span>
      </div>
    </div>
  );
}
